import jwt_decode from "jwt-decode";
import sign from "jwt-encode";
import Cookies from "js-cookie";
import { createContext } from "react";
import { decryptV2, encryptV2 } from "../Cryptography/CryptoV2";
import { getFromEncLocalStorage, storeInEncLocalStorage } from "../Utils/Utils";

//getting context from cookie
export function getContext() {
  var token = getCookie("ApplicationToken");

  // if (token === undefined) {
  //   // redirect to login if token is empty
  //   window.location.replace(window.location.origin);
  //   return null;
  // }

  var decoded;
  function getCookie(name) {
    return Cookies.get(name); // => { name: 'value' }
  }
  if (token != undefined) {
    decoded = jwt_decode(token);
  }
  return decoded;
}

//Adding context to cookie
export function addContextToCookie(payLoad) {
  const secret = "secret";
  const jwt = sign(payLoad, secret);
  document.cookie = "ApplicationToken=" + jwt + ";path=/";
}

export const deleteCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

//Adding context to cookie
export function addUserToken(payLoad) {
  var date = new Date();
  var expiresDate = new Date(date.setTime(date.getTime() + 30 * 60 * 1000));
  var expiresDateString = expiresDate.toUTCString();
  var expires = "; expires=" + expiresDateString;
  // const secret = "secret";
  const jwt = payLoad;
  document.cookie = "UserToken=" + jwt + expires + "; path=/";
}

export function addContextToLocalStorage(payLoad) {
  let encryptedRes = encryptV2(JSON.stringify(payLoad));
  storeInEncLocalStorage("pload", encryptedRes);

  //let encryptedRes = await Encrypt(JSON.stringify(payLoad));
  //storeInEncLocalStorage("pload", JSON.stringify(payLoad));
  //  return encryptedRes;
}

export function getContextFromLocalStorage() {
  let encDat = getFromEncLocalStorage("pload");
  if (encDat === undefined || encDat === null) {
    deleteLocalStorage();
    if (window.location.href !== `${window.location.origin}/login`) {
      window.location.href = `${window.location.origin}/login`;
    }
  } else {
    let encryptedRes = decryptV2(encDat);

    //let encDat = getFromEncLocalStorage("pload");
    //let encryptedRes = await Decrypt2(encDat);
    return JSON.parse(encryptedRes);
  }
}

export function deleteLocalStorage() {
  // localStorage.removeItem("pload");
  // localStorage.removeItem("token");
  // localStorage.removeItem("firstname");
  // localStorage.removeItem("subKey");
  // localStorage.removeItem("employeenumber");
  // localStorage.removeItem("userId");
  // localStorage.removeItem("ggwp");
  // localStorage.removeItem("SASTokenTime");
  // localStorage.removeItem("accoundId");
  // localStorage.removeItem("token");
  // localStorage.removeItem("token");

  localStorage.clear();
}

// loader context
// @ts-ignore
export const LoaderContext = createContext();
